import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ApiIntegration } from '../../_services/api.integration';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-process-ndr',
  templateUrl: './process-ndr.component.html',
  styleUrls: ['./process-ndr.component.scss'],
})
export class ProcessNdrComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  needActionPopup: string = 'N';
  ReattemptRequestPopup: string = 'N';
  escalatePopup: string = 'N';
  deliveryAtNewLocationPopup: string = 'N';
  actionInstructions: string;
  needActionReason: string;
  viewCustomer: any = {};
  addresses: any;
  actionReasons: any = [];
  ordersData: any;
  totalRecords: number;
  addressTypes: any = [];
  addressType: "SHIPPING";
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  geoCode: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statesList: any;
  citiesList: any;
  reattemptRadioButton: string = "Notes";

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private g: Globals, public user: User, private api: ApiIntegration) {
    this.ordersData = {
      "code": null,
      "message": null,
      "role": null,
      "noOfRecords": 1,
      "invoiceData": [{
        "id": 1,
        "orderNumber": "1001",
        "customerName": "Sandeep",
        "reason": "Customer changes his mind",
      }, {
        "id": 1,
        "orderNumber": "1002",
        "customerName": "Shareef",
        "reason": "Product is taking too long to be delivered",
      }]
    }

    this.actionReasons = [
      { label: 'Contact information not appropriate', config: 'COMMUNICATION_INFO_ISSUE' },
      { label: 'Issue with Inventory', config: 'STOCK_ISSUE' }
    ];

    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
    this.stateList();
    this.cityList();
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ChangeCityAndState() {
    this.api.getCityAndStateByPinCode(this.zip).subscribe((data: any) => {
      this.city = data.city;
      this.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }


  typeAddress1() {
    this.statusText1 = "";
    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText1 = 'Please enter address';
    }
  }

  typeCity() {
    this.statusText3 = "";
    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText3 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText4 = "";
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText4 = 'Please enter state';
    }
  }

  typeZip() {
    this.statusText5 = "";
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText5 = 'Please enter zip';
    } else if (this.zip.length != 6) {
      this.statusText5 = 'ZipCode must be minimum 6 characters';
    }
  }

  clear() {

  }

  openPopupNewLocation() {
    this.deliveryAtNewLocationPopup = 'Y';
    this.viewCustomer = {
      "code": "200",
      "message": "Success",
      "role": null,
      "organizationId": 1,
      "id": 1,
      "accountType": "ACCOUNT_OWNER",
      "companyName": "Test123",
      "ownerName": "Sandeep",
      "mobile": 8904291446,
      "email": "sandeep@snithik.com",
      "status": "ACTIVE",
      "panCard": "NO",
      "panCardNumber": null,
      "aadharCard": "NO",
      "aadhartCardNumber": null,
      "mouDocument": "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
      "adddressList": [{
        "aoId": 1,
        "address1": "Test",
        "address2": "SuperMarket",
        "city": "Hyderabad",
        "state": "Telangana",
        "country": "",
        "addressType": "BILLING",
        "addressText": "Test, , Hyderabad, Telangana, 500089",
        "zip": "500089",
        "organizationId": 1,
        "addressId": 2,
        "geoCode": null
      }],
      "addressId": null,
      "createdBy": null,
      "createdDate": "26-09-2021",
      "updatedBy": null,
      "updatedDate": "08-10-2021",
      "expiryDate": "03-10-2021",
      "gstNumber": null
    }
  }

  closePopupNewLocation() {
    this.deliveryAtNewLocationPopup = 'N';
  }

  needActionPopupOpen() {
    this.needActionPopup = 'Y';
  }

  closeNeedActionPopUp() {
    this.needActionPopup = 'N';
  }

  openEscalatePopup() {
    this.escalatePopup = 'Y';
  }

  closeEscalatePopup() {
    this.escalatePopup = 'N';
  }

  ReattemptRequestPopupOpen() {
    this.ReattemptRequestPopup = 'Y';
    this.viewCustomer = {
      "code": "200",
      "message": "Success",
      "role": null,
      "organizationId": 1,
      "id": 1,
      "accountType": "ACCOUNT_OWNER",
      "companyName": "Test123",
      "ownerName": "Sandeep",
      "mobile": 8904291446,
      "email": "sandeep@snithik.com",
      "status": "ACTIVE",
      "panCard": "NO",
      "panCardNumber": null,
      "aadharCard": "NO",
      "aadhartCardNumber": null,
      "mouDocument": "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
      "adddressList": [{
        "aoId": 1,
        "address1": "Test",
        "address2": "SuperMarket",
        "city": "Hyderabad",
        "state": "Telangana",
        "country": "",
        "addressType": "BILLING",
        "addressText": "Test, , Hyderabad, Telangana, 500089",
        "zip": "500089",
        "organizationId": 1,
        "addressId": 2,
        "geoCode": null
      }],
      "addressId": null,
      "createdBy": null,
      "createdDate": "26-09-2021",
      "updatedBy": null,
      "updatedDate": "08-10-2021",
      "expiryDate": "03-10-2021",
      "gstNumber": null
    }
  }

  closeReattemptRequestPopup() {
    this.ReattemptRequestPopup = 'N';
  }

  ngOnInit() {
  }

}
